// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"c5a2909e","245":"c5148e21"}[chunkId] + ".chunk.js";
};